const GenericMarkdownLoadingSkeleton = () => {
  return (
    <div className="w-full max-w-full animate-pulse">
      {/* Optional: Generic Header/Title shape */}
      <div className="w-1/3 mb-6 bg-gray-200 rounded h-7"></div>

      {/* Paragraph 1: Standard block of text */}
      <div className="mb-8 space-y-3">
        <div className="w-full h-4 bg-gray-200 rounded"></div>
        <div className="w-full h-4 bg-gray-200 rounded"></div>
        <div className="w-11/12 h-4 bg-gray-200 rounded"></div>
        <div className="w-4/5 h-4 bg-gray-200 rounded"></div>
      </div>

      {/* Optional: Subheading shape */}
      <div className="w-1/4 h-5 mb-4 bg-gray-200 rounded"></div>

      {/* Paragraph 2: Slightly varied length */}
      <div className="mb-8 space-y-3">
        <div className="w-full h-4 bg-gray-200 rounded"></div>
        <div className="w-full h-4 bg-gray-200 rounded"></div>
        <div className="w-5/6 h-4 bg-gray-200 rounded"></div>
      </div>

      {/* Generic indented block (mimics a list, blockquote, or code block) */}
      <div className="pl-4 mb-8 space-y-3 border-l-4 border-gray-100">
        <div className="w-3/4 h-4 bg-gray-200 rounded"></div>
        <div className="w-2/3 h-4 bg-gray-200 rounded"></div>
        <div className="w-1/2 h-4 bg-gray-200 rounded"></div>
      </div>

      {/* Paragraph 1: Standard block of text */}
      <div className="mb-8 space-y-3">
        <div className="w-full h-4 bg-gray-200 rounded"></div>
        <div className="w-full h-4 bg-gray-200 rounded"></div>
        <div className="w-11/12 h-4 bg-gray-200 rounded"></div>
        <div className="w-4/5 h-4 bg-gray-200 rounded"></div>
      </div>

            {/* Optional: Subheading shape */}
      <div className="w-1/4 h-5 mb-4 bg-gray-200 rounded"></div>

      {/* Paragraph 2: Slightly varied length */}
      <div className="mb-8 space-y-3">
        <div className="w-full h-4 bg-gray-200 rounded"></div>
        <div className="w-full h-4 bg-gray-200 rounded"></div>
        <div className="w-5/6 h-4 bg-gray-200 rounded"></div>
      </div>

      {/* Generic indented block (mimics a list, blockquote, or code block) */}
      <div className="pl-4 mb-8 space-y-3 border-l-4 border-gray-100">
        <div className="w-3/4 h-4 bg-gray-200 rounded"></div>
        <div className="w-2/3 h-4 bg-gray-200 rounded"></div>
        <div className="w-1/2 h-4 bg-gray-200 rounded"></div>
      </div>
    </div>
  );
};

export default GenericMarkdownLoadingSkeleton;
